<template>
  <div>
    <a-input placeholder="请选择商户协议" :value="chosenShowName" disabled v-if="isShowInput">
      <template #suffix>
        <a-button type="primary" @click="startChoose" v-if="$route.query.type !== 'view'" :disabled="isDisabled">选择</a-button>
      </template>
    </a-input>
    <a-modal v-if="choosing || isShowModel" :visible="true" title="请选择商户协议" :footer="null" @cancel="onCancel" width="1000">
      <div class="table-header">
        <div class="header-item">
          <a-form layout="inline">
            <a-form-item label="协议编号">
              <a-input v-model="searchForm.merchantNo" placeholder="请输入商户协议编号"/>
            </a-form-item>
            <a-form-item label="协议名称">
              <a-input v-model="searchForm.merchantName" placeholder="请输入商户协议名称"/>
            </a-form-item>
            <a-form-item>
              <a-button type="primary" @click="onSearch">查询</a-button>
            </a-form-item>
            <a-form-item>
              <a-button @click="onReset">重置</a-button>
            </a-form-item>
          </a-form>
        </div>
      </div>
      <div class="table-main">
        <a-table :columns="columns" :data-source="data" :pagination="false" rowKey="merchantNo" size="small">
          <span slot="payer" slot-scope="text, record">
            <span>{{ record.payerName }}</span><br/>
            <span style="color:#999;font-size:12px">{{ record.payerAccount }}</span>
          </span>
          <span slot="payee" slot-scope="text, record">
            <span>{{ record.payeeName }}</span><br/>
            <span style="color:#999;font-size:12px">{{ record.payeeAccount }}</span>
          </span>
          <span slot="status" slot-scope="text">
            <a-tag :color="getDictColor(configStatusDict, text)">{{ getDictLabel(configStatusDict, text) }}</a-tag>
          </span>
          <span slot="action" slot-scope="text, record">
            <a-button @click="onChoose(record)" type="primary">选择</a-button>
          </span>
        </a-table>
      </div>
      <!-- 分页部分 -->
      <div class="paginationBox">
        <a-pagination v-model="pageNo" :total="total" :page-size="pageSize" @change="onPageChange"/>
      </div>
    </a-modal>
  </div>
</template>

<script>
import {payAgrDict, getDictLabel, getDictColor} from "@/utils/bizDict/payAgrDict";

const configStatusDict = {...payAgrDict.configStatus};
delete configStatusDict.default;

export default {
  name: 'PayAgrConfigChooseDialog',
  model: {
    prop: 'chosenShowName',
    event: 'change',
  },
  props: {
    scope: {required: false, type: Object},
    chosenShowName: {required: false, type: String},
    /** 搜索表单初始值：协议编号 */
    merchantNo: {required: false, type: String},
    /** 搜索表单初始值：协议名称 */
    merchantName: {required: false, type: String},
    searchable: {required: false, type: Boolean, default: true},
    isShowInput: {required: false, type: Boolean, default: true},
    isShowModel: {required: false, type: Boolean, default: false},
    isDisabled: Boolean,
  },
  data() {
    const columns = [
      {title: '协议编号', dataIndex: 'merchantNo', align: 'center', width: 150},
      {title: '协议名称', dataIndex: 'merchantName', align: 'center', width: 160},
      {
        title: '付款方', dataIndex: 'payerAccount', align: 'center', width: 180,
        scopedSlots: {customRender: 'payer'},
      },
      {
        title: '收款方', dataIndex: 'payeeAccount', align: 'center', width: 180,
        scopedSlots: {customRender: 'payee'},
      },
      {
        title: '状态', dataIndex: 'status', align: 'center', width: 90,
        scopedSlots: {customRender: 'status'},
      },
      {title: '操作', key: 'action', align: 'center', width: 80, scopedSlots: {customRender: 'action'}},
    ];
    return {
      choosing: false,
      pageNo: 1,
      pageSize: 10,
      total: 0,
      columns,
      data: [],
      configStatusDict,
      searchForm: {
        merchantNo: '',
        merchantName: '',
      },
    };
  },
  created() {
    if (this.isShowModel) {
      this.searchForm = {
        merchantNo: this.merchantNo || '',
        merchantName: this.merchantName || '',
      };
      this.loadTableData();
    }
  },
  methods: {
    getDictLabel,
    getDictColor,

    startChoose() {
      this.searchForm = {
        merchantNo: this.merchantNo || '',
        merchantName: this.merchantName || '',
      };
      this.choosing = true;
      this.loadTableData();
    },

    onSearch() {
      this.pageNo = 1;
      this.loadTableData();
    },

    async loadTableData() {
      const queryParam = {
        status: 'EFFECTIVE',
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        merchantNo: this.searchForm.merchantNo,
        merchantName: this.searchForm.merchantName,
      };
      const res = await this.api.getPayAgrConfigList(queryParam);
      if (res.code !== 200) {
        this.$message.error(res.info || '加载商户协议失败');
      } else {
        this.data = res.data.records;
        this.total = res.data.total;
        this.pageNo = res.data.current;
        this.pageSize = res.data.size;
      }
    },

    onChoose(record) {
      this.choosing = false;
      this.$emit('change', `${record.merchantNo} - ${record.merchantName}`);
      this.$emit('chooseDone', record, this.scope);
    },

    onPageChange(page) {
      this.pageNo = page;
      this.loadTableData();
    },

    onReset() {
      this.pageNo = 1;
      this.searchForm = {merchantNo: '', merchantName: ''};
      this.loadTableData();
    },

    onCancel() {
      this.choosing = false;
      this.$emit('chooseCancel');
    },
  },
};
</script>

<style lang="less" scoped>
/deep/ .ant-modal {
  width: 1000px;

  .ant-modal-content {
    width: 100%;
  }
}

/deep/ .table-header {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 10px;
}

.paginationBox {
  margin: 10px 0;
  display: flex;
  justify-content: end;
}

.ant-btn {
  min-width: 70px;
  margin: 0;
  right: -12px;
}
</style>
